import { Tooltip, Typography } from 'antd'
import moment from 'moment'
import React from 'react'

const { Text } = Typography

interface PlanDateProps {
  date?: string | null
  tooltip: string
}

export const PlanDate: React.FC<PlanDateProps> = ({ date, tooltip }) => {
  const type = date && moment(date).isBefore(moment()) ? 'danger' : undefined
  const text = date ? moment(date).format('l') : '-'
  return (
    <Tooltip title={tooltip}>
      <Text className='w-80px self-end flex-shrink-0 text-center' type={type}>
        {text}
      </Text>
    </Tooltip>
  )
}
